<template>
  <div class='notesnote' >
    <div v-show="!isEditing">
      
      <div class="note_actions">
        	<span class='right floated edit icon' v-on:click="showForm">
				<i class='fa fa-pencil'></i>
			</span>
			<span class='right floated trash icon' v-on:click="deleteNote(note)">
				<i class='fa fa-close'></i>
			</span>
      </div>
      <div class="note_meta">
	      {{getFormattedDate(note) }} von {{note.username}}:
      </div>
      <div class="notetext" v-on:change="changeNote" v-html="getFormattetNote( note.note )">
         
      </div>      

    </div>
    
    <div class="editNoteBox" v-show="isEditing">
      <div class='form'>
          <textarea type='text' v-model="note.note" ></textarea>
          <button class="button is-small" v-on:click="hideForm">
            <i class="fa fa-check"></i>
          </button>
      </div>      
    </div>
    
  </div>
</template>

<script type="text/javascript">
  export default {
    props: ['note'],
    data() {
      return {
        isEditing: false,
        currentDate:  new Date(),
        yesterday: (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
        
      };
    },
    methods: {
	  getFormattedDate(note){
		  this.FormattedDate = note.userdate
		  var d = new Date( note.created )
		  if( d.toLocaleDateString() == this.currentDate.toLocaleDateString() )  return 'Heute'
		  if( d.toLocaleDateString() == this.yesterday.toLocaleDateString() )  return 'Gestern'
		  return this.FormattedDate
	  }, 
	    
	  changeNote(){
		console.log('change note');	    
	  },
	  getFormattetNote(note){
		  return note.replace(new RegExp('\r?\n','g'), '<br>')
	  },
      deleteNote(note) {
        this.$emit('delete-note', note);
      },
      showForm() {
        this.isEditing = true;
      },
      hideForm() {
        this.isEditing = false;
      },
    },
  };
</script>